/**
 * Registro del Service Worker para PWA — Vecino Seguro
 * Importar en src/index.jsx: import { registerSW } from './serviceWorkerRegistration';
 */

export function registerSW() {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker
        .register('/sw.js')
        .then((reg) => {
          console.log('[SW] Registrado correctamente:', reg.scope);

          // Notificar cuando hay una actualización disponible
          reg.onupdatefound = () => {
            const installing = reg.installing;
            if (!installing) return;
            installing.onstatechange = () => {
              if (installing.state === 'installed' && navigator.serviceWorker.controller) {
                console.log('[SW] Nueva versión disponible. Recarga la página para actualizar.');
              }
            };
          };
        })
        .catch((err) => console.error('[SW] Error al registrar:', err));
    });
  }
}

export function unregisterSW() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((reg) => reg.unregister())
      .catch((err) => console.error(err));
  }
}
